import styles from "./DashboardHeader.module.scss";
import { IoPersonOutline } from "react-icons/io5";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function DashboardHeader() {
  const { userName } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const location = useLocation();
  const isProfilePage = location.pathname === "/profile" || location.pathname === "/profile/";
  const isKanakUtm = localStorage.getItem("utm_source")?.toLowerCase() !== "kanak_loan_app";
  
  return (
    <header className={styles.dashboard__header}>
      <div className={styles.brand__info}>
        <div className={styles.logo}>
          {isProfilePage ? (
            <div className="back-button" onClick={() => navigate("/dashboard")}>
              <img src="/images/back_icon.svg" className="back-icon" alt="Back" />
            </div>
          ) : <img src="/images/small-logo.png" alt="" />}

        </div>
        <div className={styles.brand__name}>Hi, {userName ? userName.split(" ")[0].toLowerCase() : "Welcome"}{" "} </div>
      </div>
      {isKanakUtm ? (
        <div className={styles.profile}>
          <IoPersonOutline
            className={styles.profile_icon}
            onClick={() => navigate("/profile")}
          />
      </div>
      ) : null}
    </header>
  );
}
